import { Globe2, Lock } from "lucide-react";

const OPTS = [
  { id: "public", label: "Visible to everyone", hint: "Shows in the Groups filter. Notes stay members-only.", Icon: Globe2 },
  { id: "private", label: "Private", hint: "Hidden from the list. People join with the invite code.", Icon: Lock },
];

export const VisibilityPicker = ({ value, onChange, disabled }) => (
  <div className="grid grid-cols-2 gap-2" data-testid="group-visibility-picker">
    {OPTS.map(({ id, label, hint, Icon }) => (
      <button key={id} type="button" disabled={disabled} onClick={() => onChange(id)} data-testid={`group-visibility-${id}`}
        className={`text-left rounded-xl border px-3 py-2.5 transition-colors disabled:opacity-50 ${value === id ? "border-[#2563EB] bg-[#2563EB]/10" : "border-[#27272A] bg-[#1E1E1E] hover:border-[#3F3F46]"}`}>
        <div className="flex items-center gap-1.5 text-sm font-medium text-[#F3F4F6]"><Icon className="h-3.5 w-3.5" /> {label}</div>
        <div className="text-[11px] text-[#9CA3AF] mt-0.5 leading-snug">{hint}</div>
      </button>
    ))}
  </div>
);
